import {
  foreignBenefitFrequencyTypeOptions,
  foreignBenefitTypeOptions,
  ONE_TIME,
  FUTURE,
  CONTINUING,
  OTHER,
} from 'constants/enums/foreignActivityOptions';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { REQUIRED } from 'constants/errors';
import { isPVQForm } from 'helpers/form';
import { foreignActivitiesBenefitTypeItemValidator } from './fields';
import { ForeignActivitiesBenefitItemModel } from '../types';

export const foreignActivitiesBenefitItemValidator: ValidateJSModel<ForeignActivitiesBenefitItemModel> = {
  InterestTypes: (value, attributes, attributeName, options) => ((isPVQForm(options?.formType)) ? {} : {
    presence: true,
    array: {
      validator: { presence: true },
      length: { minimum: 1, message: REQUIRED },
    },
  }),

  BenefitType: {
    hasValue: {
      validator: { inclusion: foreignBenefitTypeOptions },
    },
  },

  OtherBenefitType: (value, attributes) => {
    if (attributes?.BenefitType?.value === 'Other') { return { hasValue: true }; }

    return {};
  },

  BenefitFrequency: {
    hasValue: {
      validator: { inclusion: foreignBenefitFrequencyTypeOptions },
    },
  },

  OneTimeBenefit: (value, attributes) => {
    if (attributes?.BenefitFrequency?.value === ONE_TIME) {
      return {
        presence: true,
        model: {
          validator: foreignActivitiesBenefitTypeItemValidator,
          benefitType: ONE_TIME,
        },
      };
    }

    return {};
  },

  FutureBenefit: (value, attributes) => {
    if (attributes?.BenefitFrequency?.value === FUTURE) {
      return {
        presence: true,
        model: {
          validator: foreignActivitiesBenefitTypeItemValidator,
          benefitType: FUTURE,
        },
      };
    }

    return {};
  },

  ContinuingBenefit: (value, attributes) => {
    if (attributes?.BenefitFrequency?.value === CONTINUING) {
      return {
        presence: true,
        model: {
          validator: foreignActivitiesBenefitTypeItemValidator,
          benefitType: CONTINUING,
        },
      };
    }

    return {};
  },

  OtherBenefit: (value, attributes) => {
    if (attributes?.BenefitFrequency?.value === OTHER) {
      return {
        presence: true,
        model: {
          validator: foreignActivitiesBenefitTypeItemValidator,
          benefitType: OTHER,
        },
      };
    }

    return {};
  },
};
